import { render, staticRenderFns } from "./RKeyValueList.vue?vue&type=template&id=14735239&scoped=true&"
import script from "./RKeyValueList.vue?vue&type=script&lang=js&"
export * from "./RKeyValueList.vue?vue&type=script&lang=js&"
import style0 from "./RKeyValueList.vue?vue&type=style&index=0&id=14735239&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14735239",
  null
  
)

export default component.exports